import { Box, Button, Checkbox, Container, FormControlLabel, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

const DatosPublicador = ({ datos, setDatos, errores, setCheck }) => {
    const [checked, setChecked] = useState(false);
    useEffect(() => {
        setCheck(checked);
    }, [checked]);
    return (
        <Box sx={{ mb: { xs: 10, lg: 0 } }}>
            <Typography sx={{ mb: 2 }} variant="h6">Datos de la persona que publica</Typography>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} lg={12}>
                    <TextField required value={datos.nombre} onChange={setDatos} fullWidth label="Nombre" name="nombre" />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <TextField value={datos.organizacion} onChange={setDatos} fullWidth label="Organización" name="organizacion" />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <TextField required type="email" value={datos.email} onChange={setDatos} fullWidth label="Correo electrónico" name="email" />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <TextField type="tel" value={datos.telefono} onChange={setDatos} fullWidth label="Teléfono" name="telefono" />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <TextField type="tel" value={datos.whatsapp} onChange={setDatos} fullWidth label="WhatsApp" name="whatsapp" />
                </Grid>
            </Grid>


            <Container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Checkbox checked={checked} onChange={() => checked ? setChecked(false) : setChecked(true)} />
                <Box sx={{ dislpay: 'flex' }}>

                    <Typography sx={{ display: 'inline' }}>
                        He leído y acepto los términos del&nbsp;
                    </Typography>
                    <Typography sx={{ display: 'inline' }} color='primary'><Link to={`https://empresas-economiasocialysolidaria.com.mx/aviso-de-privacidad/`} target='_blank'>Aviso de privacidad</Link></Typography>
                </Box>
            </Container>

        </Box >
    )
}

export default DatosPublicador